import { observer } from "mobx-react-lite";
import Layout, { Body, Item, Control } from "../cmp/layout";
import Button from "../cmp/button";
import useNav from "../hook/nav";
import useSignup from "./hook";
import Dict from "../cmp/dict";
import Data from "./data";
import Phone from "./phone";
import useModal from "../hook/modal";
import TypedField from "./field";

function Signup({ data }) {
	const { login } = useNav();
	const { show, open, close, ref } = useModal();
	const { wait, submit, value, handlers, err, addressState, innState } = useSignup();
	return <Layout id='signup' title='Регистрация' onSubmit={submit}>
		<Body>
			<Item>
				{!innState.cmp && <TypedField
					type='inn'
					icon={innState.wait ? 'load' : 'bankCard'}
					disabled={innState.wait}
					value={innState.value}
					onChange={innState.onChange}
					err={innState.err}
					onClick={innState.findCompany}
				/>}
				{innState.cmp && <Data data={innState.cmp} reset={innState.reset} {...addressState} />}
				<TypedField type='source' value={value.source} onChange={handlers.source} err={err.source} onClick={open} />
			</Item>
			<Item>
				<TypedField type='login' value={value.login} onChange={handlers.login} err={err.login} />
				<TypedField type='pwd' value={value.password} onChange={handlers.password} err={err.password} />
				<TypedField type='pwd2' value={value.password2} onChange={handlers.password2} err={err.password2} />
				<Phone value={value.phone} setValue={handlers.phone} err={err.phone} />
			</Item>
		</Body>
		<Control>
			<Button disabled={wait} children='Назад' type='base-reverse' onClick={login} />
			<Button disabled={wait || hasError(err)} children='Зарегистрироваться' type='base' onClick={submit} />
		</Control>
		{show && <Dict code='where' data={data} close={close} ref={ref} value={value.source} onSelect={handlers.source} />}
	</Layout>
}

export default observer(Signup);

function hasError(o) {
	const arr = Object.values(o);
	return arr.some(e => e);
}